import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import LogoImage from "@/components/LogoImage";

const DEFAULT_CREDITS = `FantasyRace — 69° Salita dei Monti Iblei

Sviluppato da Dinamika APS
Chiaramonte Gulfi (RG)

Un ringraziamento a piloti, commissari, volontari e appassionati della cronoscalata iblea.`;

export default function CreditsModal({ open, onOpenChange }) {
  const { data: settings } = useQuery({
    queryKey: ["settings-public"],
    queryFn: async () => (await api.get("/settings/public")).data,
  });
  const text = settings?.content?.crediti || DEFAULT_CREDITS;
  const sponsorLogo = settings?.branding?.sponsor_logo_url;
  const bgImg = settings?.branding?.credits_bg_image;

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        data-testid="credits-modal"
        aria-describedby={undefined}
        className="bg-[#1A1A1E] border-[#3F3F4C] checkered-fade overflow-hidden p-0"
        style={
          bgImg
            ? {
                backgroundImage: `linear-gradient(rgba(18,18,20,0.88), rgba(18,18,20,0.94)), url(${bgImg})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
              }
            : undefined
        }
      >
        <div className="checkered-strip" />
        <div className="p-6">
          <DialogHeader>
            <DialogTitle className="font-racing font-black text-white uppercase tracking-widest text-lg">
              Crediti <span className="text-[#FF1E27]">&</span> Info App
            </DialogTitle>
          </DialogHeader>
          <p className="mt-4 text-sm text-gray-300 whitespace-pre-line leading-relaxed">
            {text}
          </p>
          {sponsorLogo && (
            <div className="mt-6 pt-4 border-t border-[#3F3F4C]">
              <p className="font-body-sport text-[9px] font-bold tracking-[0.3em] text-gray-500 uppercase mb-2">
                Main Sponsor
              </p>
              <LogoImage src={sponsorLogo} alt="Sponsor principale" hideOnError className="h-12 max-h-12 object-contain" />
            </div>
          )}
        </div>
        <div className="checkered-strip" />
      </DialogContent>
    </Dialog>
  );
}
